import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "flowbite-react";
import { FaRegFilePdf } from "react-icons/fa";

const PrintInsumoSelectionModal = ({
  show,
  onClose,
  insumosList,
  selectedIds,
  onChangeSelectedIds,
  onConfirm,
}) => {
  const toggleId = (id) => {
    onChangeSelectedIds(
      selectedIds.includes(id)
        ? selectedIds.filter((i) => i !== id)
        : [...selectedIds, id],
    );
  };

  return (
    <Modal show={show} onClose={onClose} size="lg">
      <ModalHeader className="py-2">
        <div className="text-base mt-1.5">
          Selecionar insumos para impressão
        </div>
      </ModalHeader>
      <ModalBody>
        <div className="flex flex-col gap-1 max-h-80 overflow-y-auto">
          {insumosList.map((item) => (
            <label
              key={item.id}
              className="flex items-center gap-2 rounded-lg px-2 py-1.5 hover:bg-gray-50 cursor-pointer"
            >
              <input
                type="checkbox"
                className="rounded text-blue-600"
                checked={selectedIds.includes(item.id)}
                onChange={() => toggleId(item.id)}
              />
              <span className="text-sm text-gray-800">{item.label}</span>
            </label>
          ))}
        </div>
      </ModalBody>
      <ModalFooter className="pt-2 pb-3 flex justify-center">
        <Button disabled={selectedIds.length === 0} onClick={onConfirm}>
          <div className="flex gap-2 items-center">
            <FaRegFilePdf />
            Salvar PDF
          </div>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PrintInsumoSelectionModal;
